import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { useIntl } from 'react-intl';
import { Label, SelectNative, SelectNativeOption } from '@americanexpress/dls-react';
import { setCountryOfResidenceAction } from '../../../ducks/requestDuck';
import { getCountryOfResidence } from '../../../selectors/requestSelectors';
import useSetCountryOfResidenceHooks from '../../../hooks/useSetCountryOfResidenceHooks';
import { hasCountryOfResidenceDropdownRule } from '../../../constants/ruleConstants';
import CountryOfResidenceInfoModal from './CountryOfResidenceInfoModal';

const CountryOfResidenceDropdown = () => {
  useSetCountryOfResidenceHooks();
  const dispatch = useDispatch();
  const hasCountryOfResidenceDropdown = useConditionalFeature(hasCountryOfResidenceDropdownRule);
  const countryOfResidence = useSelector(getCountryOfResidence);
  const {
    formatMessage,
    messages: { countryOfResidencesList = [] },
  } = useIntl();
  const onChange = useCallback(
    ({ target: { value: selectedCountryOfResidence } }) => dispatch(
      setCountryOfResidenceAction(selectedCountryOfResidence)),
    [dispatch]
  );

  if (
    !hasCountryOfResidenceDropdown
    || countryOfResidencesList.length === 0
    || !countryOfResidence
  ) {
    return null;
  }

  return (
    <div className="col-md-4 col-sm-12 col-xs-12 margin-1-b-sm-down flex flex-column" data-testid="countryOfResidenceDropdown">
      <Label htmlFor="countryOfResidence" id="countryOfResidenceLabel">
        {formatMessage({ id: 'countryOfResidence.label' })}
        <CountryOfResidenceInfoModal />
      </Label>
      <SelectNative
        id="countryOfResidence"
        isTwoLined={false}
        value={countryOfResidence}
        onChange={onChange}
      >
        {countryOfResidencesList.map(({ label, value }) => (
          <SelectNativeOption key={value} value={value}>
            {label}
          </SelectNativeOption>
        ))}
      </SelectNative>
    </div>
  );
};

export default CountryOfResidenceDropdown;
